<div class="NewFlightInfoIropsView-heads" style="margin-top: 30px;"><!-- !srIropsCtrl.cancelado -->
  <div class="NewFlightInfoIropsView-dateFlight">
      <div class="fs-24px fw-regular lh-30px text-am-white">
          <span>{{ "srIrops.dateFlight" | translate }}</span>
      </div>
      <div>
          <span class="fs-32px fw-medium-x lh-42px text-am-white"><!-- srIropsCtrl.changeDay -->
              {{ affectedDepartureDateTime | localizedDate:'dd MMM' | titlecase }}
          </span>
      </div>
  </div>
  <div class="NewFlightInfoIropsView-separatorLine"></div>
  <div class="NewFlightInfoIropsView-flightNumber">
      <div class="fs-24px fw-regular lh-30px text-am-white">
          <span>
              {{ "srIrops.vuelo" | translate }}
          </span>
      </div>
      <div class="fs-32px fw-medium-x lh-42px text-am-yellow">
          <span>{{ flightNumber }}</span>
      </div>
  </div>
  <div class="NewFlightInfoIropsView-separatorLine"></div>
  <div class="NewFlightInfoIropsView-hourDeparture">
      <div class="fs-24px fw-regular lh-30px text-am-white">
          <span *ngIf="schedules == 1">
              <span>{{ "srIrops.prevDeparture" | translate: { departure: '' } }} <s>{{ firstAfected?.departureDateTime | date:'HH:mm' }}</s></span>
          </span>
          <span *ngIf="schedules == 2"> 
              <span>{{ "srIrops.prevDeparture" | translate: { departure: (' ' + firstAfected?.departureAirport) } }} <s>{{ firstAfected?.departureDateTime | date:'HH:mm' }}</s></span>
          </span>
      </div>
      <div class="fs-32px fw-medium-x lh-42px text-am-yellow">
          
          <span *ngIf="schedules == 1">{{ "srIrops.departure" | translate: { departure: '' } }} {{ timeAfected.departureTime }}</span> <!-- srIropsCtrl.horarios == 1 -->
          
          <span *ngIf="schedules == 2">{{ "srIrops.departure" | translate: { departure: (' ' + firstAfected?.departureAirport) } }} {{ timeAfected.departureTime }}</span> <!-- srIropsCtrl.horarios == 1 -->
      </div>
  </div>
  <div class="NewFlightInfoIropsView-separatorLine"></div>
  <div class="NewFlightInfoIropsView-hourArrival">
      <div class="fs-24px fw-regular lh-30px text-am-white">
          <span *ngIf="schedules == 1"> 
              <span>{{ "srIrops.prevArrival" | translate: { arrival: '' } }} <s>{{ lastAfected?.arrivalDateTime | date:'HH:mm' }}</s></span>
          </span>
          <span *ngIf="schedules == 2"> 
              <span>{{ "srIrops.prevArrival" | translate: { arrival: (' ' + lastAfected?.arrivalAirport) } }} <s>{{ lastAfected?.arrivalDateTime | date:'HH:mm' }}</s></span>
          </span>
      </div>
      <div class="fs-32px fw-medium-x lh-42px text-am-yellow">
          <span *ngIf="schedules == 1">{{ "srIrops.arrival" | translate: { arrival: '' } }} {{ timeAfected.arrivalTime }}</span>
          <span *ngIf="schedules == 2">{{ "srIrops.arrival" | translate: { arrival: (' ' + lastAfected?.arrivalAirport) } }} {{ timeAfected.arrivalTime }}</span> <!-- srIropsCtrl.horarios == 1 -->
      </div>
  </div>
</div>